import { Api } from "../api/api";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

import { LikeFrom } from "../../models/chat-room";
import { Tracker } from "../tracker/tracker";

export interface TalkData {
  chat_room_id: number;
  free_text: string;
  image_url: string;
  gift_id: number;
  stamp_id: number;
  content: string;
}

@Injectable()
export class TalkProvider {
  url: string = "talks";

  constructor(public api: Api, public tracker: Tracker) {}

  post(talkData: TalkData): Observable<any> {
    if (talkData.free_text) {
      this.tracker.pushEventForFBViaGTM("message-sep");
    }
    return this.api.post(this.url, talkData);
  }

  sendLike(chatRoomId: number, fromPage?: string): Observable<any> {
    // FIXME: ハードコーディングやめる
    let likeStampId: number = 1;
    switch (fromPage) {
      case LikeFrom.UserProfilePage:
        likeStampId = 1;
        break;
      case LikeFrom.SearchPage:
        likeStampId = 2;
        break;
      case LikeFrom.UserProfilePageFromSearchPage:
        likeStampId = 3;
        break;
      default:
        likeStampId = 1;
    }
    const talkData: TalkData = {
      chat_room_id: chatRoomId,
      free_text: "",
      gift_id: undefined,
      image_url: undefined,
      stamp_id: likeStampId,
      content: undefined,
    };
    this.tracker.pushEventForFBViaGTM("good-sep");
    return this.post(talkData);
  }

  sendRichLike(chatRoomId: number, fromPage?: string): Observable<any> {
    let likeStampId: number = 5;
    const talkData: TalkData = {
      chat_room_id: chatRoomId,
      free_text: "",
      gift_id: undefined,
      image_url: undefined,
      stamp_id: likeStampId,
      content: undefined,
    };
    return this.post(talkData);
  }

  sendChocolate(chatRoomId: number): Observable<any> {
    let chocolateStampId: number = 6;
    const talkData: TalkData = {
      chat_room_id: chatRoomId,
      free_text: "",
      gift_id: undefined,
      image_url: undefined,
      stamp_id: chocolateStampId,
      content: undefined,
    };
    return this.post(talkData);
  }

  randomTalk(text: string): Observable<any> {
    return this.api.post(this.url + "/random_talk", {
      async: true,
      text: text,
    });
  }

  randomTalkStatus(): Observable<any> {
    return this.api.get(this.url + "/random_talk_status");
  }

  multiTalk(users: number[], text: string): Observable<any> {
    return this.api.post(this.url + "/multi_talk", {
      user_ids: users,
      free_text: text,
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/talk/talk.ts